import React from 'react';

interface TableHeadingsProps {
  headings: string[];
  fullWidth?: boolean;
}

export const TableHeadings = ({ headings, fullWidth }: TableHeadingsProps) => {
  const renderHeadings = (heading: string) => {
    return (
      <div key={heading} className="pl-3">
        <p className="truncate hover:text-clip">{heading}</p>
      </div>
    );
  };

  return (
    <div className={`grid grid-flow-col auto-cols-fr pt-4 items-start ${fullWidth ? 'w-full' : 'w-11/12'}`}>
      {headings.map(renderHeadings)}
    </div>
  );
};
